export enum NavigationPanel {
  NotificationPanel = 'notification-panel',
  MobileNotificationPanel = 'mobile-notification-panel',
  MobilePanel = 'mobile-panel'
}
